/**
 * Reducer for tracking A/B experiment state.
 * Experiments are currently run via Google Optimize.
 * In Google Optimize, we dispatch actions directly on the
 * store object with the following required structure:
 *
 * window.modsyStore.dispatch({
 *  type: 'EXPERIMENT',
 *  payload: { id: '<your experiment id here>', data: {<your data here>}}
 * }))
 *
 * Any dispatched action with type='EXPERIMENT' is saved here
 * to reducer state. The payload must be an object and must
 * contain both 'id' and 'data' fields.
 *
 * Components that depend on experiments can connect
 * to the redux store and get experiment data they
 * care about using the getExperimentById selector.
 */
export const initialState = {
  packageOptionsVariant: 'variantA'
};

const experimentsReducer = (state = [], action) => {
  switch (action.type) {
    case 'EXPERIMENT':
      if (action.payload && action.payload.id && action.payload.data) {
        return [...state, action.payload];
      } else {
        return state;
      }
    case 'EXPERIMENT_PACKAGE_STYLE_VARIANT': {
      return Object.assign({}, state, {
        packageOptionsVariant: action.payload
      });
    }

    default:
      return state;
  }
};

export default experimentsReducer;

// Selectors
export const getExperimentById = (experimentId, state) => {
  return state.experiments.find(experiment => experiment.id === experimentId);
};
